module.exports = __webpack_public_path__ + "img/section4a.1de31848.png";